import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from 'components/Modal';
import i18n from 'i18n';
import fsc from 'fsc';
import { payloadFromApp } from 'utils';

const TextArea = styled.textarea`
  border: 1px solid gray;
  height: 98px;
  margin: 25px 30px;
  padding: 10px;
  resize: none;
  width: calc(100% - 22px);
`;

export default class ReportTextModal extends Component {
  static propTypes = {
    app: PropTypes.shape().isRequired,
    reportReason: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
  };

  state = {
    description: ''
  };

  handleChange = (event) => {
    this.setState({ description: event.target.value });
  };

  onSubmit = () => {
    const { app, reportReason, onClose } = this.props;
    const { description } = this.state;
    fsc
      .view('App Details')
      .action('Report App')
      .withPayload({
        ...payloadFromApp(app), // add props from app
        reportReason, // we should map the listed types to a string and make a wiki page for them
        reasonString: description // user input string if available
      })
      .send();
    onClose();
  };

  text = () => (
    <TextArea
      placeholder={i18n('component.ReportTextModal.Placeholder')()}
      value={this.state.description}
      onChange={this.handleChange}
    />
  );

  render() {
    const { reportReason, onClose, getEmailLink } = this.props;
    const { description } = this.state;

    const emailLink = getEmailLink(reportReason + ' ' + description);
    return (
      <Modal
        id="ReportTextModal"
        buttons={[
          {
            text: i18n('component.ReportTextModal.Cancel')(),
            onClick: onClose
          },
          {
            highlight: true,
            text: i18n('component.ReportTextModal.Submit')(),
            onClick: this.onSubmit,
            isAnchor: true,
            href: emailLink
          }
        ]}
        contentCenter={this.text()}
        title={i18n('component.ReportTextModal.Title')()}
        onClose={onClose}
      />
    );
  }
}
